import styled from 'styled-components';

import { ReactComponent as Chevron } from 'assets/images/chevron-small.svg';
import { ReactComponent as Ida } from 'assets/images/ida.svg';
import { ReactComponent as Vuelta } from 'assets/images/vuelta.svg';
import Button from 'components/Buttons/Button';

type ToggleProps = {
  $detailsOpen: boolean;
};

export const DropdownChevron = styled(Chevron)`
  width: 12px;
  height: 12px;
`;

export const ToggleDetails = styled.button<ToggleProps>`
  display: inline-block;
  background-color: transparent;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: normal;
  color: #626e75;
  cursor: pointer;
  width: 16px;
  text-align: right;

  & ${DropdownChevron} {
    width: 12px;
    height: 12px;
    vertical-align: middle;
    transform: ${({ $detailsOpen }) => ($detailsOpen ? 'rotate(270deg)' : 'rotate(90deg)')};
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 16px;
  background: #ffffff;
  box-shadow: 0px 5px 10px rgba(33, 34, 36, 0.04);
  border-radius: 12px;
`;

export const Wrapper = styled.div`
  width: 100%;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px;
  gap: 8px;
`;
export const Title = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  width: 100%;
  color: ${({ theme }) => theme.primaryBackgroundColor};
  align-items: center;
`;

export const SubTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #332927;
  display: flex;
  align-items: center;
`;

export const Divider = styled.div`
  height: 1px;
  background: #dbdbdb;
  width: 100%;
`;
export const IconDepart = styled(Ida)`
  color: #090b0b;
  width: 20px;
  height: 20px;
  margin-right: 5px;
`;
export const IconArrival = styled(Vuelta)`
  color: #090b0b;
  width: 20px;
  height: 20px;
  margin-right: 5px;
`;

export const CancelButton = styled(Button)``;
